module.exports = __webpack_public_path__ + "img/360.608a3644.svg";